function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.83757 8.75971C2.39659 6.41575 2.94362 4.06879 3.52164 1.73083C3.90466 0.185852 4.53268 -0.241141 6.05074 0.120853C9.18887 0.87084 12.318 1.66383 15.4411 2.47181C16.7692 2.81381 17.2192 3.5648 16.9032 4.90977C15.7601 9.76469 14.6001 14.6136 13.424 19.4605C13.113 20.7415 12.385 21.2145 11.127 20.9115C7.87082 20.1265 4.62069 19.3095 1.37555 18.4715C0.171503 18.1596 -0.209513 17.4126 0.1055 16.0376C0.661523 13.6056 1.25755 11.1837 1.83757 8.75971Z",
  fill: "#FF3819"
});

var SvgRed = function SvgRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/red.e9b4483a.svg";
export { ForwardRef as ReactComponent };